import React, { useState } from "react";
import axios from "axios";

const PropertyForm = () => {
  const [form, setForm] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

const handleSubmit = async () => {
  try {
    const payload = {
      ...form,

      is_same: form.is_same ? 1 : 0,

      purchase_amount: Number(form.purchase_amount) || 0,
      locality_price: Number(form.locality_price) || 0,
      land_acre: Number(form.land_acre) || 0,
      land_sqft: Number(form.land_sqft) || 0,
      floors: Number(form.floors) || 0,
    };

    console.log("FINAL DATA =>", payload);

    await axios.post("https://api.d2associates.in/daso/property", payload);

    alert("Saved Successfully");

  } catch (err) {
    console.log("ERROR =>", err.response?.data);
    alert("Error saving data");
  }
};
  return (
    <div style={container}>
      <div style={card}>
        <h2 style={title}>Property </h2>

    
        <Section title="Owner Details">
          <Input name="owner_name" placeholder="Name" onChange={handleChange} />
          <Input name="owner_father" placeholder="Father/Husband" onChange={handleChange} />
          <Input name="owner_contact" placeholder="Contact" onChange={handleChange} />
          <Input name="owner_address" placeholder="Address" onChange={handleChange} />
        </Section>

     
        <Section title="Borrower Details">
          <label style={checkbox}>
            <input type="checkbox" name="is_same" onChange={handleChange} />
            Same as Owner
          </label>

          <Input name="borrower_name" placeholder="Name" onChange={handleChange} />
          <Input name="borrower_father" placeholder="Father/Husband" onChange={handleChange} />
          <Input name="borrower_contact" placeholder="Contact" onChange={handleChange} />
          <Input name="borrower_address" placeholder="Address" onChange={handleChange} />
        </Section>

      
        <Section title="Location">
          <Input name="latitude" placeholder="Latitude" onChange={handleChange} />
          <Input name="longitude" placeholder="Longitude" onChange={handleChange} />
        </Section>

    
        <Section title="Property Details">
          <Input name="sale_deed_no" placeholder="Sale Deed No" onChange={handleChange} />
          <Input type="date" name="registration_date" onChange={handleChange} />
          <Input name="purchase_amount" placeholder="Purchase Amount" onChange={handleChange} />
          <Input name="locality_price" placeholder="Locality Price" onChange={handleChange} />
        </Section>

   
        <Section title="Land Area">
          <Input
            name="land_acre"
            placeholder="Acre"
            onChange={(e) => {
              const acre = e.target.value;
              setForm({
                ...form,
                land_acre: acre,
                land_sqft: acre * 43560,
              });
            }}
          />
          <Input name="land_sqft" value={form.land_sqft || ""} readOnly />
        </Section>

        <Section title="Boundaries">
          <Input name="east" placeholder="East" onChange={handleChange} />
          <Input name="west" placeholder="West" onChange={handleChange} />
          <Input name="north" placeholder="North" onChange={handleChange} />
          <Input name="south" placeholder="South" onChange={handleChange} />
        </Section>

        <Section title="Road Details">
          <select name="road_type" style={input} onChange={handleChange}>
            <option>Bitumen</option>
            <option>Concrete</option>
            <option>Murrom</option>
            <option>Fly-ash</option>
            <option>Earthen</option>
          </select>
        </Section>

        <Section title="Building Details">
          <select name="approval_status" style={input} onChange={handleChange}>
            <option>Approved</option>
            <option>Not Approved</option>
          </select>

          <Input name="floors" placeholder="No of Floors" onChange={handleChange} />
          <Input name="structure_type" placeholder="Structure Type" onChange={handleChange} />
        </Section>

        {/* REMARK */}
        <Section title="Remark">
          <textarea name="remark" style={textarea} onChange={handleChange} />
        </Section>

        <button style={button} onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default PropertyForm;








const Section = ({ title, children }) => (
  <div style={section}>
    <h4 style={sectionTitle}>{title}</h4>
    <div style={grid}>{children}</div>
  </div>
);

const Input = (props) => <input {...props} style={input} />;




/*  STYLES */

const container = {
  minHeight: "100vh",
  background: "linear-gradient(135deg, #6c4636, #D4c2BB)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px",
};

const card = {
  background: "#fff",
  borderRadius: "12px",
  padding: "25px",
  width: "100%",
  maxWidth: "900px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
};

const title = {
  textAlign: "center",
  marginBottom: "20px",
  color: "#6c4636",
};

const section = {
  marginBottom: "20px",
};

const sectionTitle = {
  marginBottom: "10px",
  color: "#333",
  borderBottom: "2px solid #eee",
  paddingBottom: "5px",
};

const grid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "10px",
};

const input = {
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ddd",
  width: "100%",
};

const textarea = {
  width: "100%",
  height: "80px",
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ddd",
};

const button = {
  width: "100%",
  padding: "12px",
  background: "#6c4636",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
};

const checkbox = {
  gridColumn: "span 2",
};